import manageReducer from "./manageReducer";

export const manageReducers = {
  manage: manageReducer,
};
